<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF AGRICULTURE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">ABOUT US</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<!-- ABOUTUS
       ================================================== -->
<section class="aboutus-style-02">
    <div class="container">
        <div class="row align-items-center mt-n1-9">
            <div class="col-lg-6 col-xl-7 mt-1-9">
                <div class="col-lg-12 order-2 order-lg-1">
                    <img src="assets/img/ArniSchool07/1.jpg" class="cover-background w-100 h-100"/>
                </div>
            </div>
            <div class="col-lg-6 col-xl-5 mt-1-9">
                <div class="section-heading text-start mb-0">
                    <span class="sub-title">ABOUT US</span>
                </div>
                <h2 class="h1 mb-1-6 text-primary">Introduction</h2>
                <p>ARNI The School of Agriculture is dedicated to preparing the upcoming generation of agriculture
                    leaders and researchers who will lead the future of sustainable farming, rural development, and food
                    security. The school nestled with rich biodiversity and agricultural heritage, provides an
                    appropriate setup for the students to learn, experiment, and grow as professionals bound to
                    transform the agriculture landscape in a better and more compelling way. Through the School, ARNI
                    trains students to become catalysts in the field of agriculture with a strong emphasis on research,
                    technology integration, and experimental learning. Our students are cultivated through industry
                    interactions and entrepreneurial skill development initiatives, fostering a culture of innovation
                    and leadership.</p>
            </div>
            <div class="col-lg-12 col-xl-12 mt-1-9">
                <p><b>Vision </b>– Our vision is to become the leading center for excellence in agriculture education
                    including
                    research-based learning and innovations. Our valuable students contribute to sustainable growth and
                    food security.
                </p>
                <p><b>Mission </b> – We are on a mission to deliver comprehensive education that integrates theoretical
                    knowledge with practical skills in agriculture science that promotes eco-friendly and sustainable
                    farming techniques to address global food challenges.
                </p>
                <h2> Master’s and Bachelors of Science in Agriculture</h2>
                <p>Arni University offers a comprehensive BSc hons in agriculture at its Arni School of Agriculture,
                    focusing on innovation, education, and hands-on learning. Located in Indora, the university offers
                    vast acres of agricultural fields for learning, demonstration, and research. The curriculum is
                    designed to align with industry needs, integrating classroom learning with hands-on experience.
                    Students engage in year-round practical experiences, including Rural Agricultural Work Experience
                    (RAWE) and Agro-Industrial Attachments, providing valuable exposure to real-world agricultural
                    settings.</p>
                <p><b>Scope </b> : The School of Agriculture offers a wealth of opportunities for students to excel
                    academically,
                    professionally, and socially. The courses cover topics in agriculture and related fields like
                    horticulture, soil science, plant breeding, and agriculture economics.
                </p>
                <ul>
                    <li> Students studying agriculture have a wide range of options, including positions in the public
                        and private sectors.
                    </li>
                    <li> Graduates can work in research and development, banking, insurance, and education. Those with
                        an agricultural degree are eligible to take several competitive tests at the federal and state
                        levels.
                    </li>
                    <li> Furthermore, it equips them to become self-sufficient entrepreneurs who use their leadership,
                        strategic, and analytical skills to build prosperous professions.
                    </li>
                </ul>
                <p>If you are dreaming of a career in the field of Agriculture Science and technologies, or want to
                    contribute to farming practices and food security, the ARNI School of Agriculture is the right place
                    for a promising future. Join us now in cultivating a greener, more sustainable world.
                </p>
            </div>
        </div>
        <div class="shape20">
            <img src="assets/img/bg/bg-02.jpg" alt="...">
        </div>
        <div class="shape18">
            <img src="assets/img/bg/bg-01.jpg" alt="...">
        </div>
        <div class="shape21">
            <img src="assets/img/bg/bg-03.jpg" alt="...">
        </div>
    </div>
</section>


<!-- COUNTER
        ================================================== -->
<section class="pt-0 ">
    <div class="container ">
        <div class="row mt-n1-9 text-center">
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper text-center">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-01.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">1</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Course</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-02.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">4</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Faculty</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-03.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">1</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Department</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mt-1-9 d-flex justify-content-center">
                <div class="counter-wrapper">
                    <div class="counter-icon">
                        <div class="d-table-cell align-middle">
                            <img src="assets/img/icons/icon-04.png" class="w-55px" alt="...">
                        </div>
                    </div>
                    <div class="counter-content">
                        <h4 class="counter-number">
                            <span class="countup">20</span>+
                        </h4>
                        <p class="mb-0 font-weight-600">Events</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- PARTNER
    ================================================== -->
<section class="bg-very-light-gray py-8">
    <div class="container">
        <div class="client-carousel owl-carousel owl-theme">
            <div class="text-center">
                <img src="assets/img/partners/partner-01.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-02.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-03.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-04.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-05.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-06.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-07.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-08.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-09.jpg" alt="...">
            </div>
            <div class="text-center">
                <img src="assets/img/partners/partner-10.jpg" alt="...">
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 ">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Agriculture</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BSC (Agriculture)</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</section>
